import { render } from "./NavbarView.vue?vue&type=template&id=581bfef0"
import script from "./NavbarView.vue?vue&type=script&lang=js"
export * from "./NavbarView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elliot/Documents/attendance-systems/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__